import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { useAuth } from '../App';

export default function Login() {
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const nav = useNavigate();

  const requestOtp = async () => {
    setLoading(true); setError('');
    try { await api.post('/auth/request-otp', { email }); setStep(2); }
    catch(e) { setError(e.response?.data?.error || 'Error sending OTP'); }
    finally { setLoading(false); }
  };

  const verifyOtp = async () => {
    setLoading(true); setError('');
    try { const { data } = await api.post('/auth/verify-otp', { email, otp }); login(data.token, data.user); nav('/'); }
    catch(e) { setError(e.response?.data?.error || 'Invalid OTP'); }
    finally { setLoading(false); }
  };

  const inp = { width:'100%', padding:'10px 12px', border:'1px solid #e5e7eb', borderRadius:8, fontSize:14, boxSizing:'border-box', outline:'none' };
  const btn = { width:'100%', padding:11, background:'#3b82f6', color:'#fff', border:'none', borderRadius:8, fontSize:14, fontWeight:500, cursor:'pointer' };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#1a1f2e' }}>
      <div style={{ background:'#fff', borderRadius:12, padding:40, width:360, boxShadow:'0 8px 32px rgba(0,0,0,.2)' }}>
        <div style={{ marginBottom:28 }}>
          <div style={{ fontSize:22, fontWeight:600, color:'#1a1f2e' }}>Byldr ERP</div>
          <div style={{ fontSize:13, color:'#9ca3af', marginTop:4 }}>P.P. Impex India</div>
        </div>
        {step === 1 ? (
          <>
            <div style={{ marginBottom:16 }}>
              <label style={{ display:'block', fontSize:13, fontWeight:500, color:'#4a5568', marginBottom:6 }}>Email address</label>
              <input value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key==='Enter'&&requestOtp()} type="email" placeholder="your@email.com" style={inp} />
            </div>
            {error && <div style={{ background:'#fef2f2', color:'#c53030', padding:'8px 12px', borderRadius:6, fontSize:13, marginBottom:12 }}>{error}</div>}
            <button onClick={requestOtp} disabled={loading || !email} style={btn}>{loading ? 'Sending...' : 'Send OTP'}</button>
            <div style={{ marginTop:12, fontSize:12, color:'#9ca3af' }}>OTP appears in the server terminal.</div>
          </>
        ) : (
          <>
            <div style={{ marginBottom:8, fontSize:13, color:'#4a5568' }}>OTP sent to <strong>{email}</strong></div>
            <div style={{ marginBottom:16 }}>
              <label style={{ display:'block', fontSize:13, fontWeight:500, color:'#4a5568', marginBottom:6 }}>Enter OTP</label>
              <input value={otp} onChange={e => setOtp(e.target.value)} onKeyDown={e => e.key==='Enter'&&verifyOtp()} type="text" placeholder="6-digit code" maxLength={6} style={{ ...inp, letterSpacing:6, fontSize:20, textAlign:'center' }} />
            </div>
            {error && <div style={{ background:'#fef2f2', color:'#c53030', padding:'8px 12px', borderRadius:6, fontSize:13, marginBottom:12 }}>{error}</div>}
            <button onClick={verifyOtp} disabled={loading || otp.length < 6} style={btn}>{loading ? 'Verifying...' : 'Sign In'}</button>
            <button onClick={() => { setStep(1); setOtp(''); setError(''); }} style={{ ...btn, marginTop:8, background:'#f3f4f6', color:'#374151' }}>Back</button>
          </>
        )}
      </div>
    </div>
  );
}
